export class TradeDataProduct implements IResponseList<ITradeDataProductItem> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ITradeDataProductItem[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    ((this.status_code = 200), (this.data = []));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class TradeDataProductDetail implements IResponse<ITradeDataProductItem> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ITradeDataProductItem | undefined;
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = undefined;
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class TradeDataPort implements IResponseList<ITradeDataPortInfo> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ITradeDataPortInfo[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  summary?: any;
  constructor() {
    ((this.status_code = 200), (this.data = []));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class TradeDataEntity implements IResponseList<ITradeDataEntity> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ITradeDataEntity[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    ((this.status_code = 200), (this.data = []));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class TradeDataEntityDetail implements IResponse<ITradeDataEntity> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ITradeDataEntity | undefined;
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    this.status_code = 200;
    this.data = undefined;
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class TradeDataBOLs implements IResponseList<ITradeData> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ITradeData[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  _isInitialData: boolean;
  constructor() {
    ((this.status_code = 200), (this.data = []));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
    this._isInitialData = true;
  }
  total_records: number;
}

export class CompanyTradeDataBOLs implements IResponseList<ICompanyTradeData> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ICompanyTradeData[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    ((this.status_code = 200), (this.data = []));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class BillOfLadingDetail implements IResponse<IBillOfLadingDetail> {
  message?: string | undefined;
  status_code: number;
  data: IBillOfLadingDetail;
  detail?: string | undefined;
  errors?: ExpectedAny[] | undefined;
  limit?: number | undefined;
  offset?: number | undefined;
  total_pages?: number | undefined;
  constructor() {
    this.data = {
      supplier_name: '',
      buyer_name: '',
      transaction: null,
      import_port: null,
      export_port: null,
      hs_code: '',
      supplier: null,
      buyer: null,
      export_country: null,
      import_country: null,
    };
    this.status_code = 200;
  }
}
export class PortOriginTransactionProportions
  implements IResponseList<ITradeDataByProportionalPortTransactionProportion>
{
  message?: string | undefined;
  status_code: number;
  warning?: string | null | undefined;
  data: ITradeDataByProportionalPortTransactionProportion[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  total_docs_count?: number | undefined;
  constructor() {
    ((this.status_code = 0), (this.data = []), (this.page = 0));
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
}

export class CompanyAggregatedByBOL implements IResponseList<ICompanyAggregatedByBOL> {
  message?: string | undefined;
  status_code: number;
  warning?: string | null | undefined;
  data: ICompanyAggregatedByBOL[];
  errors?: any[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  total_docs_count?: number | undefined;
  _isInitialData?: boolean;
  constructor() {
    this.status_code = 0;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
    this._isInitialData = true;
  }
}

export class PortsAggregatedByBOL implements IResponseList<IPortsAggregatedByBOL> {
  message?: string | undefined;
  status_code: number;
  warning?: string | null | undefined;
  data: IPortsAggregatedByBOL[];
  errors?: any[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  total_docs_count?: number | undefined;
  constructor() {
    this.status_code = 0;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
}

export class SupplierFromBuyers implements IResponseList<ISupplierFromBuyer> {
  message?: string | undefined;
  status_code: number;
  warning?: string | null | undefined;
  data: ISupplierFromBuyer[];
  errors?: any[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  total_docs_count?: number | undefined;
  constructor() {
    this.status_code = 0;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
}
export class BuyerFromSuppliers implements IResponseList<IBuyerFromSupplier> {
  message?: string | undefined;
  status_code: number;
  warning?: string | null | undefined;
  data: IBuyerFromSupplier[];
  errors?: any[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  total_docs_count?: number | undefined;
  constructor() {
    this.status_code = 0;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
}

export class PartnersFromCompany implements IResponseList<IPartnersFromCompany> {
  message?: string | undefined;
  status_code: number;
  warning?: string | null | undefined;
  data: IPartnersFromCompany[];
  errors?: any[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  total_records: number;
  total_docs_count?: number | undefined;
  constructor() {
    this.status_code = 0;
    this.data = [];
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
}

export class TradeDataMarketAnalytics implements IResponseList<any> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: any[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  _isInitialData?: boolean;
  constructor() {
    ((this.status_code = 200), (this.data = []));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
    this._isInitialData = true;
  }
  total_records: number;
}

export class TradeDataMarketAnalyticsAIExplanation implements IResponse<IMarketAnalyticsByAIRaw> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: IMarketAnalyticsByAIRaw;
  errors?: ExpectedAny[] | undefined;
  constructor() {
    ((this.status_code = 200),
      (this.data = {
        ai_report: {
          trend: '',
          anomaly: '',
          season: '',
          action: '',
        },
      }));
  }
}

export class TradeDataMarketAnalyticsCompany implements IResponseList<IMarketAnalyticsCompany> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: IMarketAnalyticsCompany[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  constructor() {
    ((this.status_code = 200), (this.data = []));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
  }
  total_records: number;
}

export class TradeDataMarketAnalyticsWorldMap implements IResponseList<any> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: any[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  _isInitialData?: boolean;
  constructor() {
    ((this.status_code = 200), (this.data = []));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
    this._isInitialData = true;
  }
  total_records: number;
}

export class TradeDataListTypeResponse implements IResponseList<ExpectedAny> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: any[];
  errors?: ExpectedAny[] | undefined;
  page: number;
  page_size: number;
  total_pages: number;
  _isInitialData?: boolean;

  constructor() {
    ((this.status_code = 200), (this.data = []));
    this.page = 0;
    this.page_size = 0;
    this.total_pages = 0;
    this.total_records = 0;
    this._isInitialData = true;
  }
  total_records: number;
}

export class TradeDataListTypeAIExplanation implements IResponse<ExpectedAny> {
  message?: string;
  status_code: number;
  warning?: string | null | undefined;
  data: ExpectedAny;
  errors?: ExpectedAny[] | undefined;
  constructor() {
    ((this.status_code = 200),
      (this.data = {
        ai_report: {
          trend: '',
          anomaly: '',
          opportunity_insight: '',
        },
      }));
  }
}
